import _ from 'underscore';

import { isValidUrl } from '@bingads-webui/url-util';

const defaultLocalizedText = {
  previewTypeStringKey: '',
  stringKey: '',
  disclaimerMessage: '',
};

export const getLocalizedText = (template, i18n) => _.defaults(
  {},
  _.mapObject(template.localizedText, val => i18n.getString(val)),
  defaultLocalizedText
);

// handle style overrides dependent on ad data
// for preview workflows with include/exclude behavior
export const updateOpacityBasedOnIncludeState = (template, adData) => {
  const { image: { IsIncluded } } = adData;

  const styleOverrides = {
    ...template.styleOverrides,
    placementContainer: {
      ...template.styleOverrides.placementContainer,
      opacity: IsIncluded ? 100 : 50,
    },
  };

  return {
    ...template,
    styleOverrides,
  };
};

export const defaultPreviewTextUrl = 'https://example.com';

export const getPreviewTexts = ({
  adData,
  skipUrlValidation,
  defaultPreviewTexts,
}) => {
  const { url, displayUrl } = adData;

  let processedUrl = url || defaultPreviewTextUrl;

  const previewTextKeys = _.keys(defaultPreviewTexts);

  if (!skipUrlValidation) {
    processedUrl = isValidUrl(url) ? new URL(url).origin : url;
  }

  const previewTextWithDefaults = _.defaults(_.pick(adData, previewTextKeys), defaultPreviewTexts);

  return _.extend(previewTextWithDefaults, {
    url: processedUrl,
    displayUrl,
  });
};
